import { css } from '@emotion/core'
import { useWatch } from '@fs/zion-form'
import { colors, List } from '@fs/zion-ui'
import React from 'react'
import Divider from '@fs/zion-ui/dist/cjs/divider'
import { useSlsStateContext } from '@fs/zion-sls'
import Droppable from '../../ui/Droppable'
import OtherPersonsMentioned from '../OtherPersonsMentioned'
import DraggablePerson from './DraggablePerson'

const activeBorderCss = css`
  outline: solid 4px ${colors.blue10};
`

const DroppableRecord = ({ record }) => {
  const { currentImageArk } = useSlsStateContext()
  const [dragInfo] = useWatch({
    name: ['dragInfo'],
  })

  const persons = record?.subElements?.filter(
    (sub) => sub?.elementType === 'PERSON' && sub?.partitionKey === currentImageArk
  )

  return (
    <>
      {persons.length > 0 && <Divider marginY="xs" fullWidth />}
      <Droppable
        id={record?.id}
        key={record?.id}
        setOverStyle={(isOver, over) =>
          isOver && over?.id !== dragInfo?.person?.recordId ? activeBorderCss : undefined
        }
      >
        <>
          {persons && persons.length > 0 && (
            <div id={`record-${record?.id}`}>
              {/* We a need a List because the PersonDisplay used in DraggablePerson is a ListItem component */}
              <List>
                {persons.map((person) => (
                  <DraggablePerson key={person?.id} person={person} record={record} />
                ))}
              </List>
            </div>
          )}
          <OtherPersonsMentioned record={record} movePersonMode />
        </>
      </Droppable>
    </>
  )
}

export default DroppableRecord
